module.exports = __webpack_public_path__ + "static/media/peer-feedback-good-luck.fbeab974.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer-feedback-good-luck.png
// module id = 565
// module chunks = 0